import { Component, ViewChild, Output, OnInit, EventEmitter } from '@angular/core';
import { UserLoginService } from '../cognito/user-login.service';
import { Router } from '@angular/router';
import * as globals from '../globals';
import * as Materialize from 'angular2-materialize/dist/index';
import { BernieService } from './bernie.service';
import { SharedService } from '../shared/shared.service';
import { DropzoneComponent } from '../dropzone/dropzone.component';
import { Observable } from 'rxjs/Rx';
import { DropzoneWorkspaceComponent } from '../dropzone/dropzone-workspace.component';
import { ProjectDataService } from '../shared/dataservice.service';
import { UploadService } from '../shared/upload.service';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { UtilsService } from '../shared/utils.service';
import { FilesizePipe } from '../projects/filesize.pipe';
import { NavbarService } from '../navbar/navbar.service';

declare var openNewBrowserWindow: any;

@Component({
  selector: 'app-bernie',
  templateUrl: './bernie.component.html',
  styleUrls: ['./bernie.component.css'],
  providers: [BernieService, UserLoginService]

})
export class BernieComponent implements OnInit {
  email: string = '';
  productname: string = 'SHAREVIEW 3D';

  projects = [];

  usagesize: number = 0;
  usagesizestr: string = '';
  usagesizepercentage: string = '';
  usagecount: number = 0;
  usagecountpercentage: string = '';
  oversizelimit: boolean = false;
  overcountlimit: boolean = false;
  private bucketname = globals.BUCKETNAME;

  errorMessage: string;
  filesToUpload: Array<File>;
  loadingprojects: boolean = true;
  uploadingproject: boolean = false;
  progressbarActive: boolean = false;
  projectloaderror: boolean = false;

  oldpassword: string = '';
  newpassword: string = '';
  confirmpassword: string = '';
  passworderrormessage: string = '';
  changepasswordicon = '';
  messagerequiredmessage: boolean = false;
  noProjects: boolean;

  sharelink: string = '';
  sharefolder: string = '';
  sharefilename: string = '';
  shareprojectid: string = '';
  shareemail: string = '';
  sharesubject: string = '';
  sharemessage: string = '';
  shareErrorMessage: string = '';

  translateprojectid: string = '';
  translatename: string = '';
  translatefilename: string = '';
  translatetype: string = 'stp';
  public dateFormat: string;


  processingTimer: any;
  processingTimerLength: number = 10000;
  processingTimerSubscription: any;

  // 0=loading, 1=file not present, 2=file present
  translatePDF: number = 0;
  translateSTP: number = 0;
  translateSTL: number = 0;
  isProcessingCount: number = 0;

  translateTimer: any;
  translateTimerLength: number = 10000;
  translateTimerSubscription: any;

  // Pagination
  public filter: string = '';
  public filter1: string = '';
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public config = {
    itemsPerPage: 12,
    currentPage: 1,
    totalItems: 1
  };

  linkchars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  tenantid: string = '';
  planid: string;
  // _dom: BrowserDomAdapter;
  _service: any;
  _projectDataService: any;
  hwv: any;
  userInterface: any;
  projectforceUpdate = false;
  tenanturl: string = '';

  modalUploadModelAction = new EventEmitter<string | MaterializeAction>();
  modalAccountInfoAction = new EventEmitter<string | MaterializeAction>();
  modalContactSupportAction = new EventEmitter<string | MaterializeAction>();
  modalViewUsageAction = new EventEmitter<string | MaterializeAction>();
  modalShareModelAction = new EventEmitter<string | MaterializeAction>();
  modalDeleteModelAction = new EventEmitter<string | MaterializeAction>();
  modalDownloadAndTranslateAction = new EventEmitter<string | MaterializeAction>();
  modalPasswordAction = new EventEmitter<string | MaterializeAction>();

  @ViewChild(DropzoneComponent) _dropzone: DropzoneComponent;
  @Output() actions: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild(DropzoneWorkspaceComponent) _dropzoneWorkspace: DropzoneWorkspaceComponent;


  constructor(private bernieService: BernieService, private router: Router,
    private service: SharedService,
    private projectDataService: ProjectDataService,
    private uploadService: UploadService,
    private utilsService: UtilsService,
    private userLoginService: UserLoginService,
    public navService: NavbarService
  ) {

    this._projectDataService = projectDataService;
    this._service = service;
  }


  ngOnInit() {
    this.navService.hide();

    this.email = localStorage.getItem('mr_email');
    this.planid = localStorage.getItem('mr_planid');
    this.dateFormat = localStorage.getItem('mr_date_format_id');
    if (typeof this.planid == 'undefined' || this.planid === '') {
      this.planid = '1';
    }

    this.processingTimerSubscription = null;
    this.translateTimerSubscription = null;

    this.tenantid = localStorage.getItem('mr_tenantid');
    this.planid = localStorage.getItem('mr_planid');

    if (typeof this.planid == 'undefined' || this.planid === '') {
      this.planid = '1';
    }

    if (this.planid === '3') {
      this.tenanturl = globals.GOVTENANTURL;
    } else {
      this.tenanturl = globals.TENANTURL;
    }

    console.log('TENANTURL:', this.tenanturl);
    this.noProjects = false;
    this.bernieService.getProjectsPage(this.config.currentPage, this.config.itemsPerPage)
      .subscribe(
      data => {
        console.log('Got projects page');

        if (Object.keys(data).length === 0) {
          this.loadingprojects = false;
          this.projectloaderror = true;
        } else {
          let projectdata = JSON.parse(data);
          this.config.currentPage = Number(projectdata.pagenum);
          this.config.totalItems = projectdata.count;

          if (!projectdata.projects.length) {
            this.noProjects = true;
          } else {

          }
          this.refreshProjects(data);
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjectsPage() error:', this.errorMessage);
        this.loadingprojects = false;
        this.projectloaderror = true;
      });
  }

  ngOnDestroy() {
    console.log('Calling ngOnDestroy');

    if (this.processingTimerSubscription != null) {
      console.log('PROCESSING TIMER STOPPED');
      this.processingTimerSubscription.unsubscribe();
    }

    if (this.translateTimerSubscription != null) {
      console.log('TRANSLATION TIMER STOPPED');
      this.translateTimerSubscription.unsubscribe();
    }
  }

  refreshProjects(data) {
    let projectdata = JSON.parse(data);
    console.log('refreshProjects');
    console.log(projectdata);

    let isProcessing = false;

    // Populate the thumbnail URLs
    for (let key in projectdata.projects) {
      // Determine the status of the model file to show
      if (projectdata.projects.hasOwnProperty(key)) {
        if (projectdata.projects[key].status == 1) {
          isProcessing = true;
        }

        // Get the filename without the extension
        let filenamenoext = projectdata.projects[key].filename.replace(/\.[^/.]+$/, '');
        if (!filenamenoext) {
          filenamenoext = ' ';
        }

        if (projectdata.projects[key].material_id == null || projectdata.projects[key].material_id == 'undefined') {
          projectdata.projects[key].material_id = 0;
        }
        projectdata.projects[key].status_id = 0;
        projectdata.projects[key].filenamenoext = filenamenoext;
        projectdata.projects[key].thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + projectdata.projects[key].id + '/' + filenamenoext + '_320x240.png';
        projectdata.projects[key].thumbnail2 = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + projectdata.projects[key].id + '/' + filenamenoext + '_100x75.png';

        let val = projectdata.projects[key];
      }

      // Determine the Part Type to show
      projectdata.projects[key].cardparttype = this.utilsService.getModelName(projectdata.projects[key].modeltype_id);

      this.projects = projectdata.projects;
    }

    this.usagesize = projectdata.metrics.size / 1000000;
    this.usagesizestr = this.usagesize.toFixed(1);
    this.usagesizepercentage = (this.usagesize / 256 * 100).toString() + '%';

    this.usagecount = projectdata.metrics.count;
    this.usagecountpercentage = (this.usagecount / 20 * 100).toString() + '%';

    this.oversizelimit = false;
    this.overcountlimit = false;
    if (this.usagesize > 256) {
      this.oversizelimit = true;
    }

    if (this.usagecount > 20) {
      this.overcountlimit = true;
    }

    this.loadingprojects = false;

    // See if any of the projects are in a processing state.  If so
    // start a timer to check the backend for them to be completed.
    if (isProcessing && this.processingTimerSubscription == null) {
      console.log('Detected a project in the processing state');
      this.processingTimer = Observable.timer(this.processingTimerLength, this.processingTimerLength);
      this.processingTimerSubscription = this.processingTimer.subscribe(t => this.checkProcessingStatus());
    }
  }

  checkProcessingStatus() {
    let processingCount;
    this.bernieService.processingUploadCheck()
      .subscribe(
      data => {
        // console.log('checkProcessingStatus data:', data);
        console.log('checkProcessingStatus');
        let processingdata = JSON.parse(data);
        processingCount = processingdata.length;

        if (processingdata.length == 0 || processingCount < this.isProcessingCount) {

          this.processingTimerSubscription.unsubscribe();
          this.processingTimerSubscription = null;

          // No projects processing, so refresh the data
          console.log('No projects in a processing state');

          this.bernieService.getProjectsPage(this.config.currentPage, this.config.itemsPerPage)
            .subscribe(
            data => {
              if (Object.keys(data).length === 0) {
                this.loadingprojects = false;
                this.projectloaderror = true;
              } else {
                let projectdata = JSON.parse(data);
                this.config.currentPage = Number(projectdata.pagenum);
                this.config.totalItems = projectdata.count;

                this.refreshProjects(data);
              }
            },
            error => {
              this.errorMessage = <any>error;
              console.error('getProjectsPage() error:', this.errorMessage);
              this.loadingprojects = false;
              // this.projectloaderror = true;
            });
        } else {
          console.log('Project(s) are still in a processing state');
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('checkProcessingStatus() error:', this.errorMessage);
      });
  }

  deleteProject(id) {
    console.log('Deleting project:', id);
    this.loadingprojects = true;
    this.bernieService.deleteProject(id)
      .subscribe(
      data => {
        window.location.reload();
      },
      error => {
        this.errorMessage = <any>error;
        console.error('deleteProject() error:', this.errorMessage);
        this.loadingprojects = false;
        this.projectloaderror = true;
      });
  }

  clearPasswordFields() {
    this.passworderrormessage = '';
    this.oldpassword = '';
    this.newpassword = '';
    this.confirmpassword = '';
  }

  changePassword() {
    console.log('Updating password');
    this.passworderrormessage = '';

    console.log('here we go');
    console.log('old:', this.oldpassword);
    console.log('new:', this.newpassword);
    console.log('confirm:', this.confirmpassword);

    if (this.oldpassword === '' || this.newpassword === '' || this.confirmpassword === '') {
      this.passworderrormessage = 'All fields are required';
      return;
    }

    if (this.newpassword !== this.confirmpassword) {
      this.passworderrormessage = 'Passwords do not match';
      return;
    }

    //this.userLoginService.changePassword(this.oldpassword, this.newpassword, this);
  }

  cognitoCallback(message: string, result: any) {
    console.log('cognitoCallback called');

    if (message != null) {
      // error
      if (message === 'Incorrect username or password.') {
        message = 'The entered Old Password is incorrect';
      }
      this.passworderrormessage = message;
      console.log('result: ' + this.passworderrormessage);
    } else {
      // success
      this.modalPasswordAction.emit({ action: 'modal', params: ['close'] });
      this.oldpassword = '';
      this.newpassword = '';
      this.confirmpassword = '';
      Materialize.toast('Password updated', 5000);
    }
  }

  sendSupportEmail(subject, message) {
    console.log('Sending support email');
    this.messagerequiredmessage = false;

    if (!subject || !message) {
      this.messagerequiredmessage = true;
      return;
    }

    Materialize.toast('Sending support message...', 5000);

    this.bernieService.sendSupportEmail(subject, message)
      .subscribe(
      data => {
        console.log('Support email send successful');
        this.messagerequiredmessage = false;
        Materialize.toast('Support message sent.', 5000);
      },
      error => {
        this.errorMessage = <any>error;
        console.error('sendSupportEmail() error:', this.errorMessage);
        this.messagerequiredmessage = false;
        Materialize.toast('Error sending support message.  Please email support@machineresearch.com directly.', 15000);
      });
  }

  setSizePercentageStyle() {
    let styles = {
      // CSS property names
      'width': this.usagesizepercentage
    };
    return styles;
  }

  setCountPercentageStyle() {
    let styles = {
      // CSS property names
      'width': this.usagecountpercentage
    };
    return styles;
  }

  onShowTranslate(projectid: string, name: string, filename: string) {
    // 0=not found, 1=translating, 2=file found, 3=error translating
    this.translatePDF = -1;
    this.translateSTP = -1;
    this.translateSTL = -1;

    console.log('projectid:', projectid);
    console.log('name:', name);
    console.log('filename:', filename);

    this.translateprojectid = projectid;
    this.translatename = name;
    this.translatefilename = filename;

    this.bernieService.translationCheck(this.tenantid, projectid)
      .subscribe(
      data => {
        console.log('TranslationCheck Status:', data);
        let json = JSON.parse(data);
        this.translateSTL = json.STL;
        this.translateSTP = json.STP;
        this.translatePDF = json.PDF;
        if (this.translateSTL == 1 || this.translateSTP == 1 || this.translatePDF == 1) {
          console.log('Translation detected.  Starting timer.');
          if (this.translateTimerSubscription == null) {
            this.translateTimer = Observable.timer(this.translateTimerLength, this.translateTimerLength);
            this.translateTimerSubscription = this.translateTimer.subscribe(t => this.checkTranslationStatus());
          }
        } else {
          if (this.translateTimerSubscription != null) {
            this.translateTimerSubscription.unsubscribe();
            this.translateTimerSubscription = null;
          }
        }
      },
      error => {
        console.error('Unable to get file status:', error.err);
      });
  }

  translate(type: string) {
    // console.log('TenantID:', this.tenantid);
    // console.log('ID:', this.translateprojectid);
    // console.log('Filename:', this.translatefilename);
    // console.log('Type:', type);

    if (type === 'stl') {
      this.translateSTL = 1;
    } else if (type === 'stp') {
      this.translateSTP = 1;
    } else if (type === 'pdf') {
      this.translatePDF = 1;
    } else {

    }

    this.bernieService.startTranslation(this.tenantid, this.translateprojectid, this.translatefilename, '.' + type)
      .subscribe(
      data => {
        console.log('startProcessing data:', data);
        // Start a timer to refresh the page when translation is complete
        if (this.translateTimerSubscription == null) {
          this.translateTimer = Observable.timer(this.processingTimerLength);
          this.translateTimerSubscription = this.translateTimer.subscribe(t => this.checkTranslationStatus());
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('startProcessing error:', this.errorMessage);
      });
  }

  checkTranslationStatus() {
    console.log('Calling checkTranslationStatus()');
    this.bernieService.translationCheck(this.tenantid, this.translateprojectid)
      .subscribe(
      data => {
        console.log('Translation status:', data);
        let json = JSON.parse(data);
        this.translateSTL = json.STL;
        this.translateSTP = json.STP;
        this.translatePDF = json.PDF;

        if (this.translateSTL !== 1 && this.translateSTP !== 1 && this.translatePDF !== 1) {
          console.log('Nothing translating, so done.');
          if (this.translateTimerSubscription != null) {
            this.translateTimerSubscription.unsubscribe();
            this.translateTimerSubscription = null;
          }
        }
      },
      error => {
        console.error('Unable to get file status:', error.err);
      });
  }

  onDownloadOriginal() {
    let url = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.translateprojectid + '/' + this.translatefilename;
    // console.log('Original URL:', url);
    window.open(url);
  }

  onDownloadTranslated(typeextension: string) {
    let url = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + this.translateprojectid + '/' + this.translatename + '.' + typeextension;
    // console.log('Translated file URL:', url);
    window.open(url);
  }

  onTranslateClose() {

  }

  fileChangeEvent(fileInput: any) {
    this.filesToUpload = <Array<File>>fileInput.target.files;
  }

  onLogout() {
    localStorage.setItem('id_token', '');
    this.userLoginService.logout();
    this.router.navigate(['/login']);
  }

  openInViewer(id: string, name: string) {
    // Build the URL
    let hwfurl = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + id + '/' + name + '.hwf';

    console.log('openInViewer() URL: ', hwfurl);
    localStorage.setItem('hwfurl', hwfurl);
    // this.router.navigate(['/viewer']);
    openNewBrowserWindow('/#/viewer', hwfurl);
  }

  onShowShare(name: string, projectid: string) {
    // Make the randomized share link
    this.shareErrorMessage = '';
    this.sharefolder = '';
    for (let i = 0; i < 20; i++) {
      this.sharefolder += this.linkchars.charAt(Math.floor(Math.random() * this.linkchars.length));
    }

    this.sharefilename = encodeURIComponent(name + '.hwf');
    this.shareprojectid = projectid;

    this.sharelink = globals.WEBSITEURL + '/#/shareview/?file=' +
      this.sharefolder + '/' + this.sharefilename;

    console.log('Share link:', this.sharelink);
  }

  onShare(event: any) {
    this.shareErrorMessage = '';
    if (!this.shareemail || !this.sharesubject || !this.sharemessage || !this.sharelink) {
      this.shareErrorMessage = 'All fields are required';
      return;
    }

    // this.actions.emit("closeModal");
    this.modalShareModelAction.emit({ action: 'modal', params: ['close'] });

    Materialize.toast('Sending share email...', 4000);

    let sharedata = {
      tenantid: this.tenantid, projectid: this.shareprojectid, email: this.shareemail, subject: this.sharesubject,
      message: this.sharemessage, link: this.sharelink, folder: this.sharefolder, filename: this.sharefilename
    };

    console.log('onShare shareData:', sharedata);

    // Clear out the dialog fields
    this.shareemail = '';
    this.sharesubject = '';
    this.sharemessage = '';

    this.bernieService.share(sharedata)
      .subscribe(
      data => {
        this.shareErrorMessage = '';
        console.log('File share successful');
        Materialize.toast('File shared successfully', 4000);
      },
      error => {
        this.shareErrorMessage = <any>error;
        console.error('onShare() error:', this.errorMessage);
        Materialize.toast('File shared failed. Please try again.', 4000);
      });
  }

  workspaceUpload() {
    let filedata = this._service.getFileAttached();
    this.filesToUpload = [filedata];


    if (typeof this.filesToUpload[0] == 'undefined' || this.filesToUpload[0] == null) {
      Materialize.toast('Please select a CAD file to upload', 4000);
      return;
    }

    this.uploadingproject = true;
    this.clearWorkspaceDropzone();
    let type = this.utilsService.determineModelType(this.filesToUpload[0].name);
    console.log('Detected filetype:', type);

    if (type == 0) {
      Materialize.toast('Invalid file type. Please select another file to upload and try again.', 4000);
      return;
    }

    let projectdetails = {
      planid: 1
    };

    this.progressbarActive = true;
    // Create the project to be able to get the project ID
    this.bernieService.addProject(this.filesToUpload, type, projectdetails)
      .subscribe(
      data => {
        console.log('Project added to DB');
        console.log('addProject data:', data);
        let projectdata = JSON.parse(data);
        let projectid = projectdata.projectid;
        console.log('Project ID:', projectid);

        let policy = projectdata.s3creds.s3Policy;
        let signature = projectdata.s3creds.s3Signature;
        let serverdate = projectdata.s3creds.serverDate;
        console.log('policy:', policy);
        console.log('signature:', signature);
        console.log('serverdate:', serverdate);

        // Upload the file to the newly created project bucket/folder
        this.uploadService.makeProjectUploadRequest(globals.TENANTURL, [], this.filesToUpload, this.tenantid, this.planid, true, projectid, policy, signature, serverdate).then((result) => {
          console.log('Uploaded file. Result:', result);
          this.uploadingproject = false;
          // translate
          this.bernieService.startProcessingUpload(projectid, this.tenantid, this.filesToUpload[0].name, this.planid)
            .subscribe(
            data => {

              this.progressbarActive = false;
              console.log('startProcessingUpload completed');
              this.modalUploadModelAction.emit({ action: 'modal', params: ['close'] });

              this.bernieService.getProjectsPage(this.config.currentPage, this.config.itemsPerPage)
                .subscribe(
                data => {
                  console.log('Got projects page');

                  if (Object.keys(data).length === 0) {
                    this.loadingprojects = false;
                    this.projectloaderror = true;
                  } else {
                    let projectdata = JSON.parse(data);
                    this.config.currentPage = Number(projectdata.pagenum);
                    this.config.totalItems = projectdata.count;

                    if (!projectdata.projects.length) {
                      this.noProjects = true;
                    } else {
                      this.noProjects = false;
                    }
                    this.refreshProjects(data);
                  }
                },
                error => {
                  this.errorMessage = <any>error;
                  console.error('getProjectsPage() error:', this.errorMessage);
                  this.loadingprojects = false;
                  this.projectloaderror = true;
                });
            },
            error => {
              this.errorMessage = <any>error;
              this.progressbarActive = false;
              this.modalUploadModelAction.emit({ action: 'modal', params: ['close'] });
              console.error('startProcessing error:', this.errorMessage);
            });
        });

      },
      error => {
        this.uploadingproject = false;
        this.errorMessage = <any>error;
        this.progressbarActive = false;

        this.modalUploadModelAction.emit({ action: 'modal', params: ['close'] });
        console.error('getProjects() error:', this.errorMessage);
      });
    this.uploadService.progress$.subscribe(
      data => {
        console.log('upload progress = ' + data);
        document.getElementById('workspaceuploadprogress').style.width = Number(data) + '%';

      });

    this.uploadingproject = false;
  }

  clearWorkspaceDropzone() {
    this._dropzoneWorkspace.clearWorkspaceDropzone();
  }

  onPageChange(number: number) {
    console.log('change to page', number);
    this.config.currentPage = number;
    this.loadingprojects = true;
    this.projects = [];

    this.bernieService.getProjectsPage(this.config.currentPage, this.config.itemsPerPage, )
      .subscribe(
      data => {
        console.log('Got projects');

        if (Object.keys(data).length === 0) {
          this.loadingprojects = false;
          this.projectloaderror = true;
        } else {
          let projectdata = JSON.parse(data);
          this.config.currentPage = Number(projectdata.pagenum);
          this.config.totalItems = projectdata.count;

          this._projectDataService.setForceUpdateBool(false);
          this.refreshProjects(data);
        }
      },
      error => {
        this.errorMessage = <any>error;
        console.error('getProjectsPage() error:', this.errorMessage);
        this.loadingprojects = false;
        this.projectloaderror = true;
      });
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/bernie/bernie.component.ts